import React from 'react';
import {Form, Textarea, List, Group} from 'components';
import {useNamedSelector} from 'helpers';

export function HowAreYou() {
  const { initialValues, keys, onChange } = useNamedSelector('clarity.form', { name: 'how-are-you' });
  return (
    <Form {...{ initialValues, onChange }}>
      <List tiny-gutter>
        <List.Title>What am I longing for, what is mostly missing in my life right now?</List.Title>
        <Textarea single name={keys[0] + '__0'} />
        <List.Title>What must I accomplish to feel satisfied and fulfilled?</List.Title>
        <Textarea single name={keys[1] + '__0'} />
        <List.Title>What have I wanted to do for a long time, but still haven't done?</List.Title>
        <Textarea single name={keys[2] + '__0'} />
        <List.Title>What is stopping me from doing what I want?</List.Title>
        <Textarea single name={keys[3] + '__0'} />
        <List.Title>If I could change two things in my life, what would they be?</List.Title>
        <Group>
          <Textarea single name={keys[4] + '__0'} />
          <Textarea single name={keys[4] + '__1'} />
        </Group>
      </List>
    </Form>
  );
}
